var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgNetflix = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 24,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9253 22.453C11.5894 22.6876 10.23 22.7579 8.82377 22.9453L4.53461 10.3829V23.4844C3.19872 23.625 1.98 23.8125 0.714355 24V0H4.27695L9.15185 13.6174V0H12.9253V22.453ZM20.3081 8.78907C21.7613 8.78907 23.9879 8.71873 25.3238 8.71873V12.4687C23.6596 12.4687 21.7144 12.4687 20.3081 12.539V18.1172C22.5113 17.9766 24.7144 17.789 26.9409 17.7186V21.3278L16.558 22.1483V0H26.9409V3.75001H20.3081V8.78907ZM40.8862 3.75009H36.9956V21.0001C35.73 21.0001 34.4643 21.0001 33.2458 21.0468V3.75009H29.3552V0H40.8864L40.8862 3.75009ZM46.9799 8.53133H52.1128V12.2812H46.9799V20.7892H43.3V0H53.7768V3.75001H46.9799V8.53133ZM59.8705 17.5078C62.0034 17.5545 64.1595 17.7189 66.2456 17.8359V21.5391C62.8941 21.328 59.5425 21.1173 56.1206 21.0468V0H59.8705V17.5078ZM69.4096 21.7969C70.6049 21.8673 71.8705 21.9376 73.0893 22.078V0H69.4096V21.7969ZM89.5191 0L84.7612 11.4141L89.5191 24C88.1127 23.8125 86.7065 23.5547 85.3002 23.3203L82.605 16.3829L79.8631 22.7579C78.5034 22.5234 77.1909 22.453 75.8318 22.2655L80.6599 11.2733L76.3004 0H80.3314L82.7924 6.3047L85.4175 0L89.5191 0Z"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 24,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9253 22.453C11.5894 22.6876 10.23 22.7579 8.82377 22.9453L4.53461 10.3829V23.4844C3.19872 23.625 1.98 23.8125 0.714355 24V0H4.27695L9.15185 13.6174V0H12.9253V22.453ZM20.3081 8.78907C21.7613 8.78907 23.9879 8.71873 25.3238 8.71873V12.4687C23.6596 12.4687 21.7144 12.4687 20.3081 12.539V18.1172C22.5113 17.9766 24.7144 17.789 26.9409 17.7186V21.3278L16.558 22.1483V0H26.9409V3.75001H20.3081V8.78907ZM40.8862 3.75009H36.9956V21.0001C35.73 21.0001 34.4643 21.0001 33.2458 21.0468V3.75009H29.3552V0H40.8864L40.8862 3.75009ZM46.9799 8.53133H52.1128V12.2812H46.9799V20.7892H43.3V0H53.7768V3.75001H46.9799V8.53133ZM59.8705 17.5078C62.0034 17.5545 64.1595 17.7189 66.2456 17.8359V21.5391C62.8941 21.328 59.5425 21.1173 56.1206 21.0468V0H59.8705V17.5078ZM69.4096 21.7969C70.6049 21.8673 71.8705 21.9376 73.0893 22.078V0H69.4096V21.7969ZM89.5191 0L84.7612 11.4141L89.5191 24C88.1127 23.8125 86.7065 23.5547 85.3002 23.3203L82.605 16.3829L79.8631 22.7579C78.5034 22.5234 77.1909 22.453 75.8318 22.2655L80.6599 11.2733L76.3004 0H80.3314L82.7924 6.3047L85.4175 0L89.5191 0Z"
  })));
});
export default SvgNetflix;
export const raw = __webpack_public_path__ + "static/media/netflix.cae69cde44fa4bb937beb17905cff1d6.svg";